import { useCallback, useState } from 'react';

import { type ProductVariants } from '@/common/types/product-details.type';

export const useProductVariant = () => {
  const [productVariant, setProductVariant] = useState<ProductVariants | null>(
    null
  );

  const setVariant = useCallback((variant: ProductVariants | undefined) => {
    if (variant) {
      setProductVariant({
        id: variant.id,
        variantTitle: variant.variantTitle,
        isAvailable: variant.isAvailable,
        isPublished: variant.isPublished,
        productVariantName: variant.productVariantName,
        productVariantPrice: variant.productVariantPrice,
        sku: variant.sku,
        variantId: variant.variantId,
      });
    } else {
      setProductVariant(null);
    }
  }, []);

  return {
    productVariant,
    setVariant,
  };
};
